/* RETTERBOX announcement-bar.js — countdown timer */
(function () {
  'use strict';

  const el = document.querySelector('[data-countdown-end]');
  if (!el) return;

  const end = new Date(el.dataset.countdownEnd).getTime();
  if (isNaN(end)) return;

  function tick() {
    const s = Math.max(0, Math.floor((end - Date.now()) / 1000));
    if (s === 0) {
      const bar = el.closest('.rb-promo__time');
      if (bar) bar.remove();
      return;
    }
    const h = Math.floor(s / 3600);
    const m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
    const sec = String(s % 60).padStart(2, '0');
    el.textContent = h + 'h ' + m + 'min ' + sec + 'sek';
    setTimeout(tick, 1000);
  }

  tick();
})();
